import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import ReportSpotModal from "../components/ReportSpotModal";
import SpotDetailTabs from "../components/spot/SpotDetailTabs";
import SpotDetailView from "../components/spot/SpotDetailView";
import { useSpotDetail } from "../hooks/useSpotDetail";

export default function PublicSpotPage() {
    const { id } = useParams();
    const [tabsMenuOpen, setTabsMenuOpen] = useState(false);
    const detail = useSpotDetail(id, {
        countView: true,
        includeVideos: true,
        includeNotes: true,
    });

    useEffect(() => {
        setTabsMenuOpen(false);
    }, [detail.activeTab]);

    const closeReportModal = () => {
        detail.setReportModalOpen(false);
    };

    if (!detail.spot) {
        return (
            <div className="cms-page-root">
                <div className="cms-page-inner spot-detail-inner">
                    <article className="cms-page-panel spot-glass-panel">
                        <p className="cms-page-loading">{detail.message || "Загрузка..."}</p>
                    </article>
                </div>
            </div>
        );
    }

    return (
        <>
            <div className="cms-page-root">
                <div className="cms-page-inner spot-detail-inner">
                    <article className="cms-page-panel spot-glass-panel spot-page">
                        <div className="spot-page__title-row">
                            <h1 className="spot-glass-title">{detail.mapTitle}</h1>
                            <Link
                                className="btn-outline"
                                to={detail.editSuggestionPath}
                                onClick={detail.requireAuthForEditSuggestion}
                            >
                                Предложить изменения
                            </Link>
                        </div>

                        <SpotDetailTabs
                            variant="page"
                            activeTab={detail.activeTab}
                            onTabChange={detail.setActiveTab}
                            includeNotesTab={detail.isAuthenticated}
                            tabsMenuOpen={tabsMenuOpen}
                            setTabsMenuOpen={setTabsMenuOpen}
                        />
                        <SpotDetailView
                            detail={detail}
                            variant="page"
                            showNotes={true}
                            showVideos={true}
                        />
                    </article>
                </div>
            </div>
            {detail.reportModalOpen ? (
                <ReportSpotModal
                    entityType="spot"
                    entityId={Number(id)}
                    onClose={closeReportModal}
                />
            ) : null}
        </>
    );
}
